import React, { Component } from 'react';
import $ from 'jQuery';

// import camera from '../../../assets/js/camera.min.js'
export default class Body extends Component {


    render() {
        return (
            <div id="body">


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/screens/Main/content.js